export default class PasteClipboard {
  constructor(upload, element) {
    this.upload = upload;
    element.addEventListener('paste', this.paste.bind(this));
  }
  paste(e) {
    if (e.clipboardData?.items) {
      const items = e.clipboardData.items;
      const files = [];
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            files.push(file);
          }
        }
      }
      if (files.length > 0) {
        e.preventDefault();
        this.upload(files);
      }
    }
  }
}
flarum.reg.add('fof-upload', 'forum/components/PasteClipboard', PasteClipboard);